Router = App.loadClass 'core::Router'

class exports.FieldsRouter extends Router

    prefix: 'Fields'
    module_name: 'FieldsRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @controller 'grower::Angular/Fields/FieldDetailsController', [
            '$scope',
            '$http',
            '$transitions',
            '$transition$',
            '$uibModalInstance',
            '$q',
            '$rootScope',
            '$state'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            # .state 'grower.fields',
            #     url: '/fields'
            #     template: '<div></div>'
            #     controller: ['$scope', ($scope) ->
            #         App.current_page = new FieldsHandler()
            #         App.current_page.init()
            #     ]

            .modalState 'grower.fields.fields.field-details',
                url: '/field-details/:id/:editing'
                templateUrl: 'backend/grower/fields/field-details-view'
                controller: 'Fields.Controllers.FieldDetailsController'
                windowClass: 'small_dialog'
                reloadOnClose: true

            .modalState 'grower.fields.field-details-elsewhere',
                url: '/field-details-elsewhere/:id/:editing'
                templateUrl: 'backend/grower/fields/field-details-view'
                controller: 'Fields.Controllers.FieldDetailsController'
                windowClass: 'small_dialog'
